import React, { useEffect } from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { mainRootState, BusinessArea } from "../../../redux/types";
import * as RestActions from "../../../redux/sagas/restActions";
import * as LoadingBooleansActions from "../../../redux/reducers/loadingBooleans/actions";
import { RestStrings } from "../../../redux/strings";
import ResourcesTableContainer from "../../../components/resourcetable/ResourcesTableContainer";

interface BusinessAreasContainerProps {
  businessareas: BusinessArea[];
  count: number;
  loadingBusinessAreas: boolean;
  resetBusinessAreas: () => void;
  loadBusinessAreas: (
    page: number,
    page_size: number,
    searchStr?: string,
    orderingStr?: string
  ) => void;
}

const BusinessAreasContainer: React.FC<BusinessAreasContainerProps> = (
  props
) => {
  const {
    loadBusinessAreas,
    businessareas,
    loadingBusinessAreas,
    resetBusinessAreas
  } = props;
  const page = 1;
  const pageSize = 20;

  useEffect(() => loadBusinessAreas(page, pageSize), [loadBusinessAreas]);
  useEffect(() => () => resetBusinessAreas(), [resetBusinessAreas]);

  const columnDefinitions = [{ name: "name", type: "link" }];

  return (
    <ResourcesTableContainer
      resources={businessareas}
      resourceName={"BusinessArea"}
      count={props.count}
      loadingResources={loadingBusinessAreas}
      routeUrl={"contracts/businessareas"}
      columnDefinitions={columnDefinitions}
      resetResources={resetBusinessAreas}
      loadResources={loadBusinessAreas}
      defaultPageSize={pageSize}
      filterDefinitions={[]}
    />
  );
};

const mapDispatchToProps = (dispatch: Dispatch, ownProps: any) => ({
  loadBusinessAreas: (
    page: number,
    pageSize: number,
    searchStr?: string,
    orderingStr?: string
  ) => {
    const searchFilter = searchStr
      ? `&filter__name__icontains=${searchStr}`
      : "";

    const orderingFilter =
      orderingStr && orderingStr !== "none"
        ? `&order__name=${orderingStr}`
        : "";

    dispatch(
      RestActions.restRequest(
        ownProps.tabId,
        RestStrings.GET,
        "BUSINESSAREAS",
        `contracts/businessareas/?page=${page}&page_size=${pageSize}${searchFilter}${orderingFilter}`
      )
    );
  },
  resetBusinessAreas: () =>
    dispatch(LoadingBooleansActions.ResetBusinessAreas(ownProps.tabId))
});

const mapStateToProps = (state: mainRootState, ownProps: any) => ({
  businessareas:
    state.tabStates[ownProps.tabId].businessAreas.businessAreas.results,
  count: state.tabStates[ownProps.tabId].businessAreas.businessAreas.count,
  loadingBusinessAreas:
    state.tabStates[ownProps.tabId].loadingBooleans.loadingBusinessAreas
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BusinessAreasContainer);
